import './footer.css';
import { useState } from 'react';


export const Footer = () => {
    const [visible, setVisible] = useState(false)
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 200) {
            setVisible(true)
        }
        else if (scrolled <= 200) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    };
    window.addEventListener('scroll', toggleVisible);

    return (
        <>
            <footer>
                <div className="body_content">
                    <div>
                        <h1>Government High School, Gangapur</h1>
                        <p>
                            Taluka: Gangapur<br />
                            District: Hathras<br />
                            State: Uttar Pradesh<br />
                            Pin Code: 204101
                        </p >
                    </div >
                </div >
                <div className="footer_wrapper">
                    <div className="foot_text">
                        &copy; Government High School, Gangapur. All rights reserved.
                    </div>
                    <div className="foot_icons">
                    </div>
                </div>
            </footer>

            <div style={{ display: visible ? 'inline' : 'none' }} className="top_icon">
                <i onClick={scrollToTop} className="fa-solid fa-arrow-up" />
            </div>
        </>
    )
}
